/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

export type GetAssessmentsOptionsFieldsItem =
  (typeof GetAssessmentsOptionsFieldsItem)[keyof typeof GetAssessmentsOptionsFieldsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssessmentsOptionsFieldsItem = {
  accumulation_tag: 'accumulation_tag',
} as const;
